import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Order Collected Activation";
const server = null;
const service = null;
const initDate = new Date();
const initDateFormat = initDate.toISOString().split('T')[0]; // yyyy-mm-dd
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    order: {
      api: {
        endpoints: {
          detail: {
            headers: {
              'Authorization': null,
            },
            doc: 'http://tr4ns10.tr4ns.com/Westfield-BulkOrder/orders/{id}',
            url: setup.setup.api.westfield_v1.url[environment] + "/orders/",
            method: 'GET'
          },
          sending_activation: {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': null,
            },
            doc: 'http://tr4ns10.tr4ns.com/Westfield-BulkOrder/orders/{id}/cc-activate',
            url: setup.setup.api.westfield_v1.url[environment] + "/orders/",
            method: 'POST'
          }
        },
        objects: {
          idVerified: {
            name: "idVerified",
            initial: false,
            type: "checkbox",
            label:
              "I confirm I have verified the customer's ID matches the order.",
            helpText: false,
            rules: ["isChecked"]
          },
          staffName: {
            name: "staffName",
            initial: "",
            type: "text",
            label: "Staff Name",
            helpText: false,
            rules: ["isNotNull"]
          },
          notes: {
            name: "notes",
            initial: "",
            type: "text",
            label: "Notes (optional)",
            helpText: false,
            rules: false
          }
        }
      }
    }
  },
  routes: {
    label: "Order Collected Activation",
    prefix: "/orders/send/activation-collected/:orderId"
  },
  setup,
  environment
}

export default config;
